import React from "react";
import { Box, FormControl, InputLabel, MenuItem, Paper, Select, TextField, } from "@material-ui/core";
import { ClientsAutocomplete } from "frontend/src/domain/client";
import { AdminLayout } from "frontend/src/pages/layouts";
import { PlaylistsSearchResultTable } from "./ui/playlists-search-result-table";
import { PlaylistCreateNew } from "./ui/playlist-create-new";
import { useSearchPlaylistForm } from "./model/use-search-playlist-form";
export var PlaylistsPage = function () {
    var _a = useSearchPlaylistForm(), title = _a.title, type = _a.type, client = _a.client, form = _a.form, showClientField = _a.showClientField;
    return (React.createElement(AdminLayout, null,
        React.createElement(Box, { display: "flex", justifyContent: "flex-end" },
            React.createElement(PlaylistCreateNew, null)),
        React.createElement(Box, { component: Paper, p: 2, mt: 1 },
            React.createElement(Box, null,
                React.createElement(TextField, { label: "Название", value: title.value, onChange: title.onChange, fullWidth: true })),
            React.createElement(Box, { mt: 1 },
                React.createElement(FormControl, { fullWidth: true },
                    React.createElement(InputLabel, null, "\u0422\u0438\u043F"),
                    React.createElement(Select, { value: type.value, onChange: type.onChange },
                        React.createElement(MenuItem, { value: "any" }, "\u041F\u0443\u0431\u043B\u0438\u0447\u043D\u044B\u0439 \u0438\u043B\u0438 \u043A\u043B\u0438\u0435\u043D\u0442\u0441\u043A\u0438\u0439"),
                        React.createElement(MenuItem, { value: "public" }, "\u041F\u0443\u0431\u043B\u0438\u0447\u043D\u044B\u0439"),
                        React.createElement(MenuItem, { value: "private" }, "\u041A\u043B\u0438\u0435\u043D\u0442\u0441\u043A\u0438\u0439")))),
            React.createElement(Box, { display: "flex", mt: 1 }, showClientField && (React.createElement(ClientsAutocomplete, { value: client.value, onChange: client.onChange, label: "Клиент" })))),
        React.createElement(Box, { component: Paper, mt: 2 },
            React.createElement(PlaylistsSearchResultTable, { params: form }))));
};
